module.exports = __webpack_public_path__ + "eb9a87cc2bb88f9783ea439d1e0bf55d.svg";